document.addEventListener('DOMContentLoaded', function () {
  // Generic "See Terms" modal opener.
  // Two ways to open a modal:
  //   Legacy:  <a id="myLink">           opens #myModaldr (free shipping)
  //   New:     <a data-terms-modal="ID"> opens #ID        (promos, etc.)
  // Markup for each modal lives in layout/theme.liquid as a .modal-dr block.

  function openModal(id) {
    var m = document.getElementById(id);
    if (m) { m.style.display = 'block'; }
  }

  // Legacy free-shipping trigger
  var legacy = document.getElementById('myLink');
  if (legacy) {
    legacy.addEventListener('click', function (event) {
      event.preventDefault();
      openModal('myModaldr');
    });
  }

  // Data-attribute triggers (promo terms button, top-bar See Terms, etc.).
  // Delegated so it works for Flickity's cloned slides too. preventDefault
  // stops a trigger nested in a slide link from also navigating the slide.
  document.addEventListener('click', function (event) {
    if (!event.target.closest) { return; }
    var trigger = event.target.closest('[data-terms-modal]');
    if (trigger) {
      event.preventDefault();
      event.stopPropagation();
      openModal(trigger.getAttribute('data-terms-modal'));
    }
  });
  document.addEventListener('keydown', function (event) {
    if ((event.key === 'Enter' || event.key === ' ') && event.target.closest) {
      var trigger = event.target.closest('[data-terms-modal]');
      if (trigger) {
        event.preventDefault();
        openModal(trigger.getAttribute('data-terms-modal'));
      }
    }
  });

  // Close buttons inside any terms modal
  document.querySelectorAll('.modal-dr .close-dr').forEach(function (closeBtn) {
    closeBtn.addEventListener('click', function () {
      var m = closeBtn.closest('.modal-dr');
      if (m) { m.style.display = 'none'; }
    });
  });

  // Click on the backdrop closes the modal
  window.addEventListener('click', function (event) {
    if (event.target && event.target.classList && event.target.classList.contains('modal-dr')) {
      event.target.style.display = 'none';
    }
  });
});
